import { render, staticRenderFns } from "./paperCard.vue?vue&type=template&id=6eb807a1&scoped=true&"
import script from "./paperCard.vue?vue&type=script&lang=js&"
export * from "./paperCard.vue?vue&type=script&lang=js&"
import style0 from "./paperCard.vue?vue&type=style&index=0&id=6eb807a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb807a1",
  null
  
)

export default component.exports